class FeaturedCollections extends HTMLElement {
  constructor() {
    super();

    this.tabsContainer = this.querySelector('.tabs-container');
    this.tabsList = this.tabsContainer.querySelector('ul');
    this.tabButtons = this.tabsList.querySelectorAll('a');
    this.tabPanels = this.querySelectorAll('.tab__panels > div');

    if (this.tabPanels.length === 0) {
      this.setAttribute('hidden', '');
      return;
    }

    this.init();
  }

  init() {
    /* Initial setup */
    this.tabsList.setAttribute('role', 'tablist');

    this.tabsList.querySelectorAll('li').forEach(li => { 
      li.setAttribute('role', 'presentation');
    });

    this.tabButtons.forEach((button, index) => {
      button.setAttribute('role', 'tab');

      if (index === 0) {
        button.setAttribute('aria-selected', 'true');
      } else {
        button.setAttribute('tabindex', '-1');
        this.tabPanels[index].setAttribute('hidden', '');
      }
    });

    this.tabPanels.forEach(panel => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('tabindex', '0');
    });

    /* Event listeners */
    this.tabsContainer.addEventListener('click', event => {
      const clickedTab = event.target.closest('a');

      if (!clickedTab) return;

      event.preventDefault();

      this.activateTab(clickedTab);
    });

    this.tabsContainer.addEventListener('keydown', event => {
      switch(event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          this.moveLeft();
          break;
        case 'ArrowRight':
          event.preventDefault();
          this.moveRight();
          break;
        case 'Home':
          event.preventDefault();
          this.activateTab(this.tabButtons[0]);
          break;
        case 'End':
          event.preventDefault();
          this.activateTab(this.tabButtons[this.tabButtons.length - 1]);
          break;
      }
    });
  }

  moveLeft() {
    const activeTab = this.tabsList.querySelector('[aria-selected="true"]');
    const previousTab = activeTab.parentNode.previousElementSibling;

    if (!previousTab) {
      this.activateTab(this.tabButtons[this.tabButtons.length - 1]);
    } else {
      this.activateTab(previousTab.querySelector('a'));
    }
  }

  moveRight() {
    const activeTab = this.tabsList.querySelector('[aria-selected="true"]');
    const nextTab = activeTab.parentNode.nextElementSibling;

    if (!nextTab) {
      this.activateTab(this.tabButtons[0]);
    } else {
      this.activateTab(nextTab.querySelector('a'));
    }
  }

  activateTab(clickedTab) {
    const activePanelId = clickedTab.getAttribute('href');
    const activePanel = this.querySelector(activePanelId);

    this.tabButtons.forEach(button => {
      button.setAttribute('aria-selected', 'false');
      button.setAttribute('tabindex', '-1');
    });

    this.tabPanels.forEach(panel => {
      panel.setAttribute('hidden', '');
    });

    activePanel.removeAttribute('hidden');

    clickedTab.setAttribute('aria-selected', 'true');
    clickedTab.setAttribute('tabindex', '0');
    clickedTab.focus();
  }
}

customElements.define('featured-collections', FeaturedCollections);